"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTransitionGroup = require("react-transition-group");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOP_SHADOW_CLASS = 'co-shadow--bottom-150';
var BOTTOM_SHADOW_CLASS = 'co-shadow--top-150';
var DURATION = 200;
var TRANSITION_STYLES = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};
var STYLES = {
  position: 'absolute',
  width: '100%',
  height: '1px',
  content: '',
  zIndex: 1,
  opacity: 0,
  transition: "opacity ".concat(DURATION, "ms ease-in-out")
};

function Shadow(_ref) {
  var position = _ref.position,
      visible = _ref.visible;
  var cx = position === 'top' ? TOP_SHADOW_CLASS : BOTTOM_SHADOW_CLASS;
  return _react.default.createElement(_reactTransitionGroup.Transition, {
    in: visible,
    timeout: DURATION,
    mountOnEnter: true,
    unmountOnExit: true
  }, function (state) {
    return _react.default.createElement("div", {
      className: cx,
      style: _objectSpread({}, STYLES, _defineProperty({}, position, -1), TRANSITION_STYLES[state])
    });
  });
}

Shadow.propTypes = {
  position: (0, _propTypes.oneOf)(['top', 'bottom']).isRequired,
  visible: _propTypes.bool
};
var _default = Shadow;
exports.default = _default;
Shadow.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Shadow",
  "props": {
    "position": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'top'",
          "computed": false
        }, {
          "value": "'bottom'",
          "computed": false
        }]
      },
      "required": true,
      "description": ""
    },
    "visible": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};